import { useTranslation } from "react-i18next"
import { Pill } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { Card, CardHeader, CardHeaderTitle } from "@/components/ui/card"

export const EPrescriptionCheck = () => {
  const { t } = useTranslation()

  const openEPrescriptionPage = () => {
    window.open("https://pharmavista.ch/de/prescription", "_blank")
  }

  return (
    <Card className="h-fit w-92.5">
      <CardHeader>
        <CardHeaderTitle data-testid="card-header-title-content" className="flex items-center gap-4">
          {t("admin.advanced.ePrescriptionCheck.title")}
        </CardHeaderTitle>
        <div className="flex justify-end">
          <Button variant="tertiary" className="p-2" onClick={openEPrescriptionPage}>
            <Pill className="text-on-surface-subdued" />
          </Button>
        </div>
      </CardHeader>
    </Card>
  )
}
